<template>
  <div>
    <div class="content">
      <div
        class="contTitle"
        :style="info.namecolor ? 'color:' + info.namecolor + ';' : ''"
      >
        {{ info.name }}
      </div>
      <div class="time">
        {{ info.create_time }}
        <div class="txt" @click="FxContShowJs">
          分享
          <!-- <vshare :vshareConfig="vshareConfig"></vshare> -->
        </div>
      </div>
      <div class="cont" v-html="info.content"></div>
      <div class="fujian" v-if="fileUrl">
        附件：<a style="color: #1890ff" :href="fileUrl" :download="fileName"
          >报名表</a
        >
      </div>
    </div>
    <div class="butBox">
      <div class="text" @click="jump(last.id)">
        上一条：{{ last.name ? last.name : "暂无上一条" }}
      </div>
      <div class="text" @click="jump(next.id)">
        下一条：{{ next.name ? next.name : "暂无下一条" }}
      </div>
    </div>
    <FxCont @show="delShow" :imgBox="info.code" v-if="FxContShow" />
  </div>
</template>
<script>
import FxCont from "../component/fxCont.vue";

// import Vue from "vue";
// import vshare from "vshare";
// Vue.use(vshare);
export default {
  components: {
    FxCont,
  },
  name: "",
  data() {
    return {
      FxContShow: false,
      info: {},
      last: {},
      next: {},
      fileUrl: "",
      fileName: "报名表",
      vshareConfig: {
        shareList: [
          // 此处放分享列表（ID）
          "weixin",
        ],
        common: {
          //此处放置通用设置
          bdUrl: "",
          bdText: "11111111",
        },
        share: [
          {
            //此处放置分享按钮设置
          },
        ],
        slide: [
          //此处放置浮窗分享设置
        ],
        image: [
          //此处放置图片分享设置
        ],
        selectShare: [
          //此处放置划词分享设置
        ],
      },
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.vshareConfig.common.bdUrl = window.location.href;
    this.get();
  },
  methods: {
    FxContShowJs() {
      this.FxContShow = true;
    },
    delShow() {
      this.FxContShow = false;
    },
    get() {
      this.$get("/nozzle/web/news_get", {
        id: this.id,
      }).then((res) => {
        console.log(res);
        res.data.create_time = this.$moment(res.data.create_time).format(
          "YYYY年M月D日"
        );
        if (res.data.filepath) {
          this.fileUrl = this.$imgUrl + res.data.filepath[0].path_name;
        }
        this.info = res.data;
        this.last = res.last;
        this.next = res.next;
      });
    },
    jump(id) {
      if (id) {
        this.id = id;
        this.get();
        // this.$router.replace({
        //   path: "/newsCont",
        //   query: {
        //     id,
        //   },
        // });
      }
    },
  },
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
/deep/tbody {
  border: 1px solid #c9c9c9;
}

/deep/tr {
  border-bottom: 1px solid #c9c9c9;
}

/deep/td {
  padding: 5px 10px;
  border-right: 1px solid #c9c9c9;
  text-align: center;
  p {
    margin-bottom: 0 !important;
  }
}

.content {
  width: 1280px;
  margin: auto;
  background-color: #fff;
  overflow: hidden;
  margin-top: 15px;

  .contTitle {
    font-size: 24px;
    font-weight: 600;
    margin-top: 20px;
    text-align: center;
  }

  .time {
    text-align: center;
    color: #9c9c9c;
    padding: 10px 0;
    border-bottom: 1px solid #ebebeb;
    position: relative;
    .txt {
      position: absolute;
      top: 10px;
      right: 20px;
      color: #097ee4;
      cursor: pointer;
      .bdsharebuttonbox {
        width: 300px;
        height: 70px;
        a {
          width: 50px;
          height: 50px;
        }
      }
    }
  }

  .cont {
    padding: 25px;
    font-size: 18px;

    a {
      color: #097ee4 !important;
      cursor: pointer;
    }

    .txt {
      text-indent: 2em;
      color: #666;
      line-height: 150%;
      margin-bottom: 10px;
    }
  }
}

/deep/a {
  color: #097ee4 !important;
  cursor: pointer;
}

.butBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 1280px;
  margin: auto;
  margin-top: 15px;
  color: #9c9c9c;
  padding-bottom: 80px;

  .text {
    cursor: pointer;
  }
}

a {
  color: #097ee4 !important;
  cursor: pointer;
}

.fujian {
  margin-top: 20px;
  padding-left: 20px;
  margin-bottom: 20px;
  font-size: 18px;

  a {
    color: #097ee4 !important;
    cursor: pointer;
  }

  span {
    color: #097ee4;
    cursor: pointer;
  }
}
</style>
